<div class="mediacontainer" #mediacontainer>
    <!-- Playing the saved copy has to happen inside an iframe pointed at a page in the
         offline worker's own scope - a <video src> on this page is controlled by ngsw and
         never reaches that worker. See offline-video-playback.service.ts getPlaybackUrl. -->
    <iframe *ngIf="offlinePlayerUrl" [src]="offlinePlayerUrl" class="offline-video-frame"
            title="Offline video" frameborder="0" allowfullscreen></iframe>
    <video controls #video id="my-player" class="video-js vjs-default-skin vjs-big-play-centered" preload="metadata" playsinline [ngStyle]="{display: !offlinePlayerUrl && media.type.startsWith('video') ? 'inherit': 'none'}"></video>
    <div [ngStyle]="{display: media.type.startsWith('audio') ? 'inherit': 'none'}">
        <br><br>
        <audio controls #audio preload="metadata"></audio>
    </div>
    <!-- Offline mode P5 — absent entirely unless offlineDownloadEligible (flag on, not
         admin, entitlement covers this module, renditions exist, browser supports the
         playback mechanism). -->
    <div *ngIf="offlineDownloadEligible && (!isDownloadedOffline || offlineCopyStale)" class="offline-download mt-2">
        <select [(ngModel)]="selectedRenditionIndex" [disabled]="downloading" class="form-control form-control-sm d-inline-block w-auto">
            <option *ngFor="let r of renditions; let i = index" [value]="i">{{ r.label }} ({{ (r.bytes / 1048576).toFixed(0) }}MB)</option>
        </select>
        <button type="button" class="btn btn--sm m-0" [disabled]="downloading" (click)="downloadForOffline()">
            {{ downloading ? 'Downloading ' + downloadPercent + '%...' : (offlineCopyStale ? 'Update saved copy' : 'Save for offline') }}
        </button>
    </div>
    <!-- No offline copies yet. 'noteligible' deliberately renders nothing: that media can never
         have them, and asking again is what used to re-trigger a full transcode per page view. -->
    <div *ngIf="!offlineDownloadEligible && !isDownloadedOffline && offlineDownloadSupported
                && (renditionStatus === 'notrequested' || renditionStatus === 'failed')"
         class="offline-download mt-2">
        <button type="button" class="btn btn--sm m-0" [disabled]="preparingRenditions" (click)="prepareForOffline()">
            {{ preparingRenditions ? 'Requesting...' : 'Prepare for offline' }}
        </button>
    </div>
    <p *ngIf="!offlineDownloadEligible && !isDownloadedOffline && renditionStatus === 'building'"
       class="offline-download-status text-xs mb-0 mt-2">
        Preparing the offline copy. Check back shortly.
    </p>
    <p *ngIf="isDownloadedOffline" class="offline-download-status text-xs mb-0 mt-2">
        <i class="fa fa-check-circle" aria-hidden="true"></i> Available offline<span *ngIf="offlineCopyStale"> &mdash; this video has been updated since you saved it</span>
    </p>
</div>